// The classics, as the page loads them; everything else about rounds is shared with the edge.

import type { Round } from "../../shared/game/rounds.ts";

export * from "../../shared/game/rounds.ts";

type ClassicsFile = { version: 1; rounds: Omit<Round, "coin" | "kind">[] };

let classics: Promise<Round[]> | null = null;

export function loadClassics(): Promise<Round[]> {
  classics ??= fetch("/rounds/classics.json")
    .then((response) => {
      if (!response.ok) throw new Error(`classics: ${response.status}`);
      return response.json() as Promise<ClassicsFile>;
    })
    .then((file) => file.rounds.map((round) => ({ ...round, coin: round.symbol, kind: "classic" as const })))
    .catch((error: unknown) => {
      classics = null;
      throw error;
    });
  return classics;
}
